/* unplugin-vue-components disabled */import script from "./Component1.vue?vue&type=script&setup=true&name=Component1&lang=js"
export * from "./Component1.vue?vue&type=script&setup=true&name=Component1&lang=js"

const __exports__ = script;

export default __exports__